import React, { useState, useEffect } from "react";
import { useHookstate } from "@hookstate/core";
import globalAuthStateStore from "../../../../../stores/globalAuthStateStore";
import { VirtualLibrarianService } from "../../../../../services/VirtualLibrarianService";
import VirtualLibrarianAvailableContentTable from "./table";
//import { useNavigate } from "react-router-dom";
import { useNavigate } from "../../../../../components/Navigate";

const VirtualLibrarianAvailableContent = () => {
  const navigate = useNavigate();
  const [availableContent, setAvailableContent] = useState([]); // State for selected tab index

  const authStore = useHookstate(globalAuthStateStore);
  const vlService = React.useMemo(
    () => new VirtualLibrarianService(authStore),
    [authStore]
  );

  useEffect(() => {
    async function fetchData() {
      const result = await vlService.getAvailableContent();
      if (result) {
        setAvailableContent(result.Data);
      }
    }
    fetchData();
  }, []);

  const handleOnEdit = (id) => {
    navigate(`/admin/content/${id}`);
  };

  return (
    <>
      <VirtualLibrarianAvailableContentTable
        filteredItems={availableContent}
        onEdit={handleOnEdit}
      />
    </>
  );
};

export default VirtualLibrarianAvailableContent;
